import React from 'react';
import PropTypes from 'prop-types';
import {
  CheckboxGroup,
  FileDropzone,
  InputText,
  Radio,
  Textarea,
} from '@othermachines/react-form-kit';

import {
  Fieldset,
  FileDropzoneCloser,
} from '../../../Shared';

import {
  allowedFileTypesString,
  checkboxGroupTheme,
  inputTheme,
  inputThemeShort,
  maxFileSize,
  radioTheme,
  textareaTheme,
} from '../../../lib';


const formName = 'Site Signs & Safety Signs';

const defaultValues = {
  'Quantity': '',
  'Size': '',
};

const fields = [
  'Quantity',
  'Size',
];

const Component = ({
  submitForm: {
    control,
    formState,
    register,
    setValue,
    unregister,
    watch,
  },

}) => {

  return (
    <Fieldset legend={formName}>

      <InputText
        inputTextId='Quantity'
        inputTextName='Quantity'
        register={register}
        formState={formState}
        label='Quantity'
        theme={inputThemeShort}
      />

      <InputText
        inputTextId='Size'
        inputTextName='Size'
        register={register}
        formState={formState}
        label='Size'
        theme={inputTheme}
      />
    </Fieldset>
  );
};

Component.propTypes = {
  submitForm: PropTypes.shape({
    control: PropTypes.object.isRequired,
    formState: PropTypes.object.isRequired,
    register: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    unregister: PropTypes.func.isRequired,
    watch: PropTypes.func.isRequired,
  }).isRequired,
};

export default Component;
export { defaultValues, fields, formName };
